import * as STEP_KEYS from "../../consts/stepKeys";
import { deepGet } from "../../../../utils";

export const onStepOptionSelect = (props, value, currentStep, nextStep) => {
  const {
    completed,
    updateAppointmentDetail,
    goToStep,
    isOpen,
    goBackToStep,
    completeStep,
    toggleControl
  } = props;

  if (isOpen) {
    toggleControl(currentStep, false);
  }
  updateAppointmentDetail(currentStep, value);
  if (!completed) {
    completeStep(currentStep);
  } else {
    goBackToStep(currentStep);
  }

  goToStep(nextStep);
};

export const findNextStep = (step, config) => {
  let nextStep = "";
  switch (step) {
    case STEP_KEYS.SPECIALTY_TYPE:
      return STEP_KEYS.APPOINTMENT_TYPE;

    case STEP_KEYS.APPOINTMENT_TYPE:
      nextStep =
        config.preSelectPractitioner || !config.practitionerFirst
          ? STEP_KEYS.LOCATION
          : STEP_KEYS.PRACTITIONER;

      return nextStep;

    case STEP_KEYS.PRACTITIONER:
      nextStep = STEP_KEYS.LOCATION;

      if (!config.practitionerFirst) {
        if (config.isPhoneConsult) {
          nextStep = STEP_KEYS.TIMEZONE;
        } else {
          nextStep = STEP_KEYS.APPOINTMENT_DATE_TIME;
        }
      }

      return nextStep;

    case STEP_KEYS.LOCATION:
      nextStep = STEP_KEYS.APPOINTMENT_DATE_TIME;

      if (config.locationFirst) nextStep = STEP_KEYS.PRACTITIONER;
      else if (config.isPhoneConsult) nextStep = STEP_KEYS.TIMEZONE;

      return nextStep;

    case STEP_KEYS.TIMEZONE:
      return STEP_KEYS.APPOINTMENT_DATE_TIME;

    default:
      return undefined;
  }
};

export const onPractitionerSelect = (props, value) => {
  const { practitionerFirst, isPhoneConsult } = props;
  const nextStep = findNextStep(STEP_KEYS.PRACTITIONER, {
    practitionerFirst,
    isPhoneConsult
  });
  onStepOptionSelect(props, value, STEP_KEYS.PRACTITIONER, nextStep);
};

export const onLocationSelect = (props, location) => {
  const isPhoneConsult = props.siteConsultTypes.some(
    type =>
      type.siteId === deepGet(location, ["locationId"]) &&
      type.consultType === 1
  );

  const { locationFirst } = props;
  onStepOptionSelect(
    props,
    location ? location.locationId : "ANY",
    STEP_KEYS.LOCATION,
    findNextStep(STEP_KEYS.LOCATION, { isPhoneConsult, locationFirst })
  );

  if (!isPhoneConsult) {
    const timeZoneId = location
      ? props.timeZones.find(
          ts =>
            ts.timezoneUID.toLowerCase() ===
            deepGet(location, ["timeZone", "timezoneId"]).toLowerCase()
        ).timezoneUID
      : deepGet(props.options[0], ["timeZone", "timezoneId"]);

    if (timeZoneId) {
      props.updateAppointmentDetail(STEP_KEYS.TIMEZONE, timeZoneId);
    }
  }
};



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/stepHelpers.js